
import moment from 'moment'
import { wtApiCall } from 'src/helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import SODIssuancePDF from 'src/PDF/SODIssuancePDF'

export const SOD_STATUS_JUST_PLACED = 1
export const SOD_STATUS_APPROVED = 2
export const SOD_STATUS_CANCELLED = 3
export const SOD_STATUS_REVIEWED = 4

export const SOD_STATUS_NAME = {
  1: 'Just Placed',
  2: 'Approved',
  3: 'Cancelled',
  4: 'Reviewed',
}

export const SOD_STATUS_DROPDOWN_OPTIONS = [
  { value: SOD_STATUS_JUST_PLACED, label: SOD_STATUS_NAME[SOD_STATUS_JUST_PLACED] },
  { value: SOD_STATUS_REVIEWED, label: SOD_STATUS_NAME[SOD_STATUS_REVIEWED] },
  { value: SOD_STATUS_APPROVED, label: SOD_STATUS_NAME[SOD_STATUS_APPROVED] },
  { value: SOD_STATUS_CANCELLED, label: SOD_STATUS_NAME[SOD_STATUS_CANCELLED] },
]

export const SODIssuanceModel = {
  branch_id: 0,
  branch: { name: '' },
  sale_order_id: '',
  sale_order: { code: '' },
  sale_order_delivery_id: '',
  sale_order_delivery: { code: '' },
  warehouse_id: '',
  warehouse: { name: '' },
  issuance_date: moment().format('YYYY-MM-DD'),
  created_by_id: 0,
  created_by: { name: '' },
  reviewed_by_id: 0,
  reviewed_by: { name: '' },
  reviewed_at: '',
  approved_by_id: 0,
  approved_by: { name: '' },
  approved_at: '',
  created_at: '',
  updated_by_id: 0,
  updated_by: { name: '' },
  updated_at: '',
  sod_issuance_details: [],
}

export const downloadSodIssuancePdf = (id, canViewReviewedBy = true, onLoadingChange = () => {}) => {
    onLoadingChange(true)
    wtApiCall(
      'sod_issuance_pdf/' + id,
      {},
      'get',
      (response) => {
        const { data } = response
        try {
          SODIssuancePDF(data, { canViewReviewedBy })
        } finally {
          onLoadingChange(false)
        }
      },
      (error) => {
        onLoadingChange(false)
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }
